import { render, staticRenderFns } from "./SorteoPopup.vue?vue&type=template&id=6d70bd90&scoped=true&"
import script from "./SorteoPopup.vue?vue&type=script&lang=ts&"
export * from "./SorteoPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70bd90",
  null
  
)

export default component.exports